import React, { useState } from 'react';
import ServiceRequestsList from './ServiceRequestsList';
import ServiceRequestDetailModal from './ServiceRequestDetailModal';
import ServiceExecutiveComplaintRegistrationModal from './ServiceExecutiveComplaintRegistrationModal';

const ServiceExecutiveRequestsPage = ({ title, description, fixedStatus }) => {
  const user = JSON.parse(localStorage.getItem('roadserve_current_user') || '{}');
  const [statusFilter, setStatusFilter] = useState(fixedStatus || '');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [registrationOpen, setRegistrationOpen] = useState(false);
  const [listKey, setListKey] = useState(0);

  const handleDetailClose = () => {
    setDetailOpen(false);
    setSelectedRequest(null);
    setListKey((prev) => prev + 1);
  };

  return (
    <div className="space-y-6 pb-20 lg:pb-0">
      <ServiceRequestsList
        key={listKey}
        user={user}
        status={statusFilter}
        onStatusChange={(value) => {
          if (!fixedStatus) setStatusFilter(value);
        }}
        searchTerm={searchTerm}
        onSearchTermChange={setSearchTerm}
        onOpenDetail={(request) => {
          setSelectedRequest(request);
          setDetailOpen(true);
        }}
        onOpenRegistration={() => setRegistrationOpen(true)}
        title={title}
        description={description}
        hideStatusFilters={Boolean(fixedStatus)}
      />

      <ServiceRequestDetailModal
        open={detailOpen}
        requestId={selectedRequest?.id}
        onClose={handleDetailClose}
        user={user}
      />

      <ServiceExecutiveComplaintRegistrationModal
        open={registrationOpen}
        onClose={() => setRegistrationOpen(false)}
        executiveId={user?.id}
        executiveName={user?.name || ''}
        onSuccess={() => setListKey((prev) => prev + 1)}
      />
    </div>
  );
};

const ServiceExecutiveComplaints = () => (
  <ServiceExecutiveRequestsPage
    title="Complaints"
    description="Pending service requests needing attention"
    fixedStatus="pending"
  />
);

const ServiceExecutiveOrders = () => (
  <ServiceExecutiveRequestsPage
    title="Orders"
    description="Completed service requests"
    fixedStatus="completed"
  />
);

export { ServiceExecutiveComplaints, ServiceExecutiveOrders };